document.addEventListener('DOMContentLoaded', () => {
  const search = document.querySelector('[data-search]');
  if (search) {
    search.addEventListener('keydown', e => {
      if (e.key === 'Enter' && search.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(search.value.trim());
      }
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.addToCart;
      if (!id) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({items:[{id:Number(id),quantity:1}]})
        });
        window.location.href = '/cart';
      } catch(e) {
        btn.disabled = false;
      }
    });
  });
});

// Keedog V15: galeria de imagens, opções visuais e seleção correta de variantes
(function () {
  function initProductV15(root) {
    if (!root || root.dataset.v15Ready === 'true') return;
    root.dataset.v15Ready = 'true';

    const mainImage = root.querySelector('[data-main-product-image]');
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.imageSrc;
        if (mainImage && src) {
          mainImage.style.opacity = '0';
          window.setTimeout(() => {
            mainImage.src = src;
            mainImage.removeAttribute('srcset');
            mainImage.style.opacity = '1';
          }, 120);
        }
        root.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

    const jsonEl = root.querySelector('[data-product-variants-json]');
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-product-price]');
    const pixPriceEl = root.querySelector('[data-product-pix-price]');
    const cardPriceEl = root.querySelector('[data-product-card-price]');
    const installmentEl = root.querySelector('[data-product-installment]');
    const addBtn = root.querySelector('[data-add-button]');
    const buyBtn = root.querySelector('[data-buy-now]');
    let variants = [];
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
    }

    const selectedOptions = () => Array.from(root.querySelectorAll('.variant-group')).map(group => {
      const checked = group.querySelector('[data-option-value]:checked');
      return checked ? checked.value : null;
    });

    function updateAvailability() {
      const groups = Array.from(root.querySelectorAll('.variant-group'));
      groups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-value]').forEach(input => {
          const proposed = selectedOptions();
          proposed[groupIndex] = input.value;
          const possible = variants.some(v => v.available && proposed.every((value, idx) => !value || v.options[idx] === value));
          const label = input.closest('.variant-choice');
          if (label) label.classList.toggle('is-unavailable', !possible);
          input.disabled = !possible;
        });
      });
    }

    function syncVariant() {
      if (!variants.length) return;
      const options = selectedOptions();
      let variant = variants.find(v => v.options.length === options.length && v.options.every((value, idx) => value === options[idx]));
      if (!variant) variant = variants.find(v => v.available && v.options.every((value, idx) => !options[idx] || value === options[idx]));
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl && variant.priceFormatted) priceEl.textContent = variant.priceFormatted;
      if (cardPriceEl && variant.priceFormatted) cardPriceEl.textContent = variant.priceFormatted;
      if (pixPriceEl && variant.pixPriceFormatted) pixPriceEl.textContent = variant.pixPriceFormatted;
      if (installmentEl && variant.installmentFormatted) installmentEl.textContent = variant.installmentFormatted;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'ADICIONAR AO CARRINHO' : 'ESGOTADO';
      }
      if (buyBtn) buyBtn.disabled = !variant.available;
      if (variant.featuredImage && mainImage) {
        mainImage.src = variant.featuredImage;
        mainImage.removeAttribute('srcset');
        root.querySelectorAll('[data-gallery-thumb]').forEach(t => {
          const same = (t.dataset.imageSrc || '').split('?')[0] === variant.featuredImage.split('?')[0];
          t.classList.toggle('is-active', same);
        });
      }
      updateAvailability();
    }

    root.querySelectorAll('[data-option-value]').forEach(input => input.addEventListener('change', syncVariant));

    const qty = root.querySelector('input[name="quantity"]');
    const minus = root.querySelector('[data-qty-minus]');
    const plus = root.querySelector('[data-qty-plus]');
    if (qty && minus) minus.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value || 1) - 1));
    if (qty && plus) plus.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value || 1) + 1));

    if (buyBtn) {
      buyBtn.addEventListener('click', async () => {
        const id = variantInput && variantInput.value;
        if (!id || buyBtn.disabled) return;
        buyBtn.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({id:Number(id), quantity:Number(qty ? qty.value : 1)})
          });
          if (!response.ok) throw new Error('Não foi possível adicionar ao carrinho.');
          window.location.href = '/checkout';
        } catch (e) {
          buyBtn.disabled = false;
          window.alert(e.message || 'Não foi possível concluir a compra.');
        }
      });
    }

    syncVariant();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-root]').forEach(initProductV15);
  });
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-product-root]');
    if (root) initProductV15(root);
  });
})();
